require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-pages-broker-project.json") })
        }
      }, "path---en-pages-broker-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-pages-broker-project!./.cache/json/en-pages-broker-project.json
// module id = 747
// module chunks = 231608221292675